import { render, staticRenderFns } from "./DataSubjectsTable.vue?vue&type=template&id=53a030f4&"
import script from "./DataSubjectsTable.vue?vue&type=script&lang=js&"
export * from "./DataSubjectsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports